const o="Info";export{o as DEFAULT_TITLE_ICON_NAME};
//# sourceMappingURL=AccordionItem.types.js.map
